<div *ngIf="!isHidden" class="wrapper">
  <nav class="menu" [class.open]="openMenu">
    <a *ngIf="inTest" [routerLink]="['bem-vindo']" class="button-wrapper">
      <img src="assets/img/logo-segcommerce-blue-small.png" />
    </a>
    <a *ngIf="!inTest" class="button-wrapper">
      <img src="assets/img/logo-segcommerce-blue-small.png" />
    </a>
    <ul>
      <li>
        <a
          (click)="closeMenu()"
          [routerLink]="['visao-geral']"
          routerLinkActive
          #mlv="routerLinkActive"
          [class.active]="mlv.isActive"
          title="dashboard"
        >
          <!-- <i class="ic" [class.ic-graph-active]="mlv.isActive"  [class.ic-graph]="!mlv.isActive"></i> -->
          <span class="icon-dashboard"></span>
        </a>
      </li>
      <li>
        <a
          (click)="closeMenu()"
          [routerLink]="['pedidos']"
          routerLinkActive
          #mlp="routerLinkActive"
          [class.active]="mlp.isActive"
          title="Pedidos"
        >
          <!-- <i class="ic" [class.ic-order-active]="mlp.isActive" [class.ic-order]="!mlp.isActive"></i> -->
          <span class="icon-order"></span>
        </a>
      </li>
      <li>
        <a
          (click)="closeMenu()"
          [routerLink]="['clientes']"
          routerLinkActive
          #mlcliente="routerLinkActive"
          [ngClass]="{
            active:
              router.isActive('app/cliente-cadastro', false) ||
              mlcliente.isActive
          }"
          title="Clientes"
        >
          <!-- <i class="ic" [class.ic-customer]="!mlcliente.isActive" [ngClass]="{'ic-customer-active': router.isActive('app/cliente-cadastro', false) || mlcliente.isActive }"></i> -->
          <span class="icon-user"></span>
        </a>
      </li>
      <li>
        <a
          (click)="closeMenu()"
          [routerLink]="['estoque']"
          routerLinkActive
          #mle="routerLinkActive"
          [ngClass]="{
            active: router.isActive('app/produto', false) || mle.isActive
          }"
          title="Produtos"
        >
          <!-- <i class="ic" [class.ic-tag]="!mle.isActive" [ngClass]="{'ic-tag-active': router.isActive('app/produto', false) || mle.isActive }"></i> -->
          <span class="icon-products"></span>
        </a>
      </li>
      <li>
        <a
          (click)="closeMenu()"
          [routerLink]="['descontos']"
          routerLinkActive
          #mlc="routerLinkActive"
          [ngClass]="{
            active: router.isActive('app/descontos', false) || mlc.isActive
          }"
          title="Descontos"
        >
          <!-- <i class="ic" [class.ic-coupon]="!mlc.isActive" [ngClass]="{'ic-coupon-active': router.isActive('app/descontos', false) || mlc.isActive }"></i> -->
          <span class="icon-discount"></span>
        </a>
      </li>
      <li>
        <a
          (click)="closeMenu()"
          [routerLink]="['vitrine']"
          routerLinkActive
          #mlve="routerLinkActive"
          [ngClass]="{
            active:
              router.isActive('app/vitrine-cadastro', false) || mlve.isActive
          }"
          title="Vitrines"
        >
          <!-- <i class="ic" [class.ic-vitrine]="!mlve.isActive" [ngClass]="{'ic-vitrine-active': router.isActive('app/vitrine-cadastro', false) || mlve.isActive }"></i> -->
          <span class="icon-showcase"></span>
        </a>
      </li>
      <li class="link-setting">
        <a
          (click)="closeMenu()"
          [routerLink]="['configuracao']"
          routerLinkActive
          #mlvs="routerLinkActive"
          [ngClass]="{
            active: router.isActive('app/settings', false) || mlvs.isActive
          }"
        >
          <!-- <i class="ic" [class.ic-settings]="!mlvs.isActive" [ngClass]="{'active': router.isActive('app/settings', false) || mlvs.isActive }"></i> -->
          <span class="icon-settings"></span>
        </a>
      </li>
    </ul>
  </nav>
  <div
    (click)="toogleMenu()"
    class="mask-complete"
    [class.open]="openMenu"
  ></div>
  <section
    class="wrapper-content"
    [ngClass]="{
      'wrapper-setting': router.isActive('app/settings', false) || mlvs.isActive
    }"
  >
    <header class="top-nav">
      <button (click)="toogleMenu()" class="btn-open-menu" type="button">
        <fa-icon [icon]="faBars"></fa-icon>
      </button>

      <main-indicators
        (indicatorScreen)="openCloseIndicatorcreen()"
        *ngIf="indicatorScreen === true"
      ></main-indicators>

      <form
        [formGroup]="searchFrm"
        (ngSubmit)="onSubmitSearch()"
        novalidate
        class="ipt-search prelative"
        [class.opacity]="searchVisible"
      >
        <input
          id="searchField"
          type="text"
          formControlName="searchField"
          [placeholder]="placeholderSearch"
          (keyup)="search()"
          [class.dnone]="!searchVisible"
        />
        <i
          class="ic ic-magnifying"
          [class.dnone]="searchField.value != '' && searchField.value != null"
        ></i>
        <a
          (click)="clearField()"
          class="btn-close dnone-sm"
          [class.dnone]="searchField.value == '' || searchField.value == null"
        ></a>
        <a
          (click)="openFilter($event)"
          class="btn-filtros"
          [class.dnone]="!searchFilter"
          >Filtros</a
        >
      </form>
      <nav>
        <a
          [routerLink]="['configuracao']"
          routerLinkActive
          #mla="routerLinkActive"
          class="btn strong dnone"
        >
          Configurações
        </a>
        <a href="https://venda.wotica.com.br"
          target="_blank"
          class="btn btn-link link-gosite"
          style="margin-right: 30px"
        >
          <i class="icon-move" title="Ir para loja"></i>
          Nova Venda
        </a>
        <a
          (click)="openCloseIndicatorcreen()"
          class="btn btn-link link-gosite dnone-sm"
          style="margin-right: 30px"
        >
          <i class="icon-chart" title="Indicadores"></i>
          Indicadores
        </a>
        <a
          *ngIf="!inTest"
          [routerLink]="['/tv']"
          class="btn btn-link link-gosite"
          style="margin-right: 30px"
        >
          <fa-icon [icon]="faTv"></fa-icon>
          Modo TV
        </a>
        <a
          (click)="logoff()"
          class="btn btn-link link-gosite"
          style="margin-right: 30px"
        >
          Sair do painel
        </a>
        <a class="btn prelative link-chat dnone">
          <i class="red-full-circle"></i>
          <i class="ic ic-chat"></i>
        </a>
        <a class="btn dnone">
          <i class="ic ic-user-circle"></i>
        </a>
      </nav>
      <nav *ngIf="pageName == 'dashboard'" class="dflex-sm">
        <a
          *ngIf="url_estabelecimento"
          [href]="url_estabelecimento"
          target="_blank"
          class="btn btn-link link-gosite"
          style="margin-right: 30px"
        >
          <i class="icon-move" title="Ir para loja"></i>
          Loja
        </a>
        <a
          *ngIf="!inTest"
          [routerLink]="['/tv']"
          class="btn btn-link link-gosite"
          style="margin-right: 30px"
        >
          <fa-icon [icon]="faTv"></fa-icon>
          Modo TV
        </a>
        <a
          (click)="logoff()"
          class="btn btn-link link-gosite"
          style="margin-right: 30px"
        >
          Sair
        </a>
      </nav>
    </header>
    <div class="wrapper-inner">
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
<div *ngIf="isHidden" class="wrapper">
  <router-outlet></router-outlet>
</div>
